import { LayoutDetails, LayoutItem, Position } from '../types';

export function calculateLayoutItemPosition(details: LayoutDetails, item: LayoutItem): Position {
  return {
    top: Math.round((details.rowHeight + details.margin.y) * item.y + details.containerPadding.y),
    left: Math.round((details.columnWidth + details.margin.x) * item.x + details.containerPadding.x),
    // we don't support infinity so the usual issues with that doesn't apply here
    width: Math.round(details.columnWidth * item.w + Math.max(0, item.w - 1) * details.margin.x),
    height: Math.round(details.rowHeight * item.h + Math.max(0, item.h - 1) * details.margin.y),
  };
}
